var $ = require('./$');
module.exports = function(C){
  if($.DESC && $.FW)$.setDesc(C, require('./$.wks')('species'), {
    configurable: true,
    get: $.that
  });
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-es6-polyfill/~/core-js/modules/$.species.js
 ** module id = 125
 ** module chunks = 0
 **/